
import React, { useState, useEffect, useContext, Component, useRef } from "react";
import "./login.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/fvAxios";
import Footer from "../../reusable-components/footer/footer";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CryptoJS from "crypto-js";

function LoginEmailVerification() {

    const params = new URLSearchParams(window.location.search);
    // const UserName = params.get("UserName");
    // const Password = params.get("Password");
    const RememberMe = params.get("RememberMe");
    const [NewEmail, setNewEmail] = React.useState('');
    const [spinner, setSpinner] = React.useState(false);
    const navigate = useNavigate();

    const [USER, setUSER] = useState('');

    // const decryptPassword = (encryptedPassword) => {
    //     const secretKey = "MyStrongSecretKey123";
    //     const decoded = decodeURIComponent(encryptedPassword);
    //     const bytes = CryptoJS.AES.decrypt(decoded, secretKey);
    //     const plain = bytes.toString(CryptoJS.enc.Utf8);
    //     return plain || "(Invalid or corrupted data)";
    // };

    const SpinnerClose = () => {
        setSpinner(false);
    };

    useEffect(() => {
        setUSER(localStorage.getItem("ValidUser"));
        const keyDownHandler = e => {
            if (e.key === 'Enter') {
                e.preventDefault();
                UpdateEmail();
            }
        };
        document.addEventListener('keydown', keyDownHandler);
        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
        // const Pass = decryptPassword(Password);
        // setPASS(Pass);

    }, [NewEmail]);

    const UpdateEmail = () => {
        // const secretKey = "MyStrongSecretKey123";
        // const encrypted = CryptoJS.AES.encrypt(PASS, secretKey).toString();
        // const urlSafeEncrypted = encodeURIComponent(encrypted);

        setSpinner(true);
        const details = {
            "email": NewEmail,
            "userName": USER
        }
        axios.post("Login/UpdateEmail", details)
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    if (res?.data?.responseMessage == "Success") {
                        navigate("/LoginVerification?RememberMe=" + RememberMe + "&NewEmail=" + NewEmail);
                        // navigate("/LoginVerification?UserName=" + UserName + "&RememberMe=" + RememberMe + "&NewEmail=" + NewEmail + "&Password=" + urlSafeEncrypted)
                    }
                } else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
                setSpinner(false);
            })
    }
    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {/*-------Verification code---*/}
            <div id="verify" className="first-verify__loginContainer">
                <div >
                    <div className='first-verify__logo'></div>
                    <div className='first-verify__loginSubContainer'>
                        <div id="wrongusername" className="first-verify__forgetPasswordContainer">
                            <div className="first-verify__logoContaineremailverification"></div>
                            <span className='first-verify__loginHeading'>{"Enter your email"}</span>
                            <span className='first-verify__loginSubheading'>
                                {/* {"Email does not exist, please provide your email to proceed."} */}
                                {"Please provide your email address. A verification code will be sent to you."}
                            </span>
                            <div className='first-verify__logindetails'>
                                <span className='password-label'>{"Email"}</span>
                                <TextField sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                }} id="outlined-basic" placeholder={"Enter your Email"} value={NewEmail} onChange={e => setNewEmail(e.target.value)} inputProps={{ className: "login-password" }} variant="outlined" />
                            </div>
                            <div className='first-verify__logindetails padding-top-0 text-align-center'>
                                <Button variant="contained" className="login-button" sx={{ textTransform: "capitalize", padding: "15px" }} onClick={UpdateEmail} >{"Send code"}</Button>
                                <Button variant="outlined" className="login-button-backtologin"
                                    onClick={() => navigate("/")}><ArrowBackIcon />{"Back"}</Button>
                            </div>
                        </div>

                    </div>
                    <Footer />
                </div>
            </div>

        </>
    )
}

export default LoginEmailVerification